import { ServiceBase } from "@app/shared";
import { SSOConfig } from "./apiModels";

class SSOSchemesService extends ServiceBase {
  private ssoSchemesEndpoint = `${this.authenticationEndpoint}/api/sso-schemes`;

  public async delete(schemeName: string): Promise<void> {
    await this.makeDelete(`/${schemeName}`, null, this.ssoSchemesEndpoint);
  }

  public async get(clientId: number): Promise<SSOConfig> {
    const result = await this.makeOptionalGet<SSOConfig>(`/${clientId}`, null, null, this.ssoSchemesEndpoint);
    return result || null;
  }

  public async patch(ssoConfig: SSOConfig): Promise<void> {
    await this.makePatch<void>(`/${ssoConfig.schemeName}`, ssoConfig, false, this.ssoSchemesEndpoint);
  }

  public async post(ssoConfig: SSOConfig): Promise<SSOConfig> {
    const result = await this.makePost<SSOConfig>("", ssoConfig, this.ssoSchemesEndpoint);
    return result || null;
  }

  public async getMetadataDocument(metadataPath: string): Promise<void> {
    await this.makeGet<void>(metadataPath, null, this.authenticationEndpoint);
  }

  public async validateSigningCertificate(certBase64: string): Promise<boolean> {
    return await this.makePost<boolean>('/validate-certificate', certBase64, this.ssoSchemesEndpoint);
  }
}

export {
  SSOSchemesService,
};
